import { FC } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import {
  DENTITION_TYPE,
  DENTITION_TYPE_OPTIONS,
  TOOTH_MOVEMENT_RESTRICTION,
  TOOTH_MOVEMENT_RESTRICTION_OPTIONS
} from 'constants/prescriptionOptions';
import { translate } from 'utils';

import { FormLabel } from './FormLabel/FormLabel';
import RhfRadioGroup from './RadioGroup/RhfRadioGroup/RhfRadioGroup';
import { RHFTextArea } from './RHFTextArea/RHFTextArea';
import RhfToothChart from './ToothChart/RhfToothChart';
interface Props {
  fieldName: string;
  title: string;
  animateLabel: string;
  isDisabled?: boolean;
  isUpperDisabled?: boolean;
  isLowerDisabled?: boolean;
  isToothChartRestricted?: boolean;
}
const ToothMovementRestriction: FC<Props> = ({
  fieldName,
  title,
  isDisabled,
  animateLabel,
  isUpperDisabled,
  isLowerDisabled,
  isToothChartRestricted
}) => {
  const {
    watch,
    formState: { errors }
  } = useFormContext();

  const watchRestrictionSelection = watch(`${fieldName}.restriction`);
  const watchDentitionSelection = watch(`${fieldName}.dentitionSelection`);
  const restrictedAdultToothChartValue = watch(
    fieldName.replace(/\.toothMovementRestriction$/, '.toothInformation') +
      '.toothChart'
  );
  const restrictedPrimaryToothChartValue = watch(
    fieldName.replace(/\.toothMovementRestriction$/, '.toothInformation') +
      '.primaryToothChart'
  );
  const fieldError = _.get(errors, `${fieldName}`);
  return (
    <div className='flex flex-col'>
      <FormLabel
        label={translate(title)}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={animateLabel}
      />
      <div>
        <RhfRadioGroup
          inputProps={{ disabled: isDisabled }}
          options={TOOTH_MOVEMENT_RESTRICTION_OPTIONS}
          name={`${fieldName}.restriction`}
          className='flex flex-row space-x-16'
          radioClassName='border-RADIO_BORDER'
          radioItemFont='md:text-17px text-sm '
        />
      </div>

      {watchRestrictionSelection ===
        TOOTH_MOVEMENT_RESTRICTION.SELECT_TEETH_SHOULD_NOT_BE_MOVED && (
        <div className='my-6 ml-5'>
          <RhfRadioGroup
            inputProps={{ disabled: isDisabled }}
            options={DENTITION_TYPE_OPTIONS}
            name={`${fieldName}.dentitionSelection`}
            className='flex flex-row space-x-16 mb-6'
            radioClassName='border-RADIO_BORDER'
            radioItemFont='md:text-17px text-sm'
          />
          {(watchDentitionSelection === DENTITION_TYPE.ADULT_DENTITION ||
            !watchDentitionSelection) && (
            <RhfToothChart
              isBaby={false}
              showError={false}
              name={`${fieldName}.toothChart`}
              disabled={isDisabled}
              isUpperDisabled={isUpperDisabled}
              isLowerDisabled={isLowerDisabled}
              isToothChartRestricted={isToothChartRestricted}
              restrictedToothChartValue={restrictedAdultToothChartValue}
            />
          )}
          {watchDentitionSelection === DENTITION_TYPE.PRIMARY_DENTITION && (
            <RhfToothChart
              isBaby={true}
              showError={false}
              name={`${fieldName}.primaryToothChart`}
              disabled={isDisabled}
              isUpperDisabled={isUpperDisabled}
              isLowerDisabled={isLowerDisabled}
              isToothChartRestricted={isToothChartRestricted}
              restrictedToothChartValue={restrictedPrimaryToothChartValue}
            />
          )}
        </div>
      )}
      <div className='bg-GRAY5 flex flex-col p-4 rounded-2xl mt-4'>
        <p className='mb-3 text-14px'>
          {translate('tooth_movement_restriction.instruction')}
        </p>
        <RHFTextArea
          name={`${fieldName}.primaryDentition`}
          autogrow
          inputProps={{
            disabled: isDisabled,
            placeholder: translate('settings.please_type_here')
          }}
          maxgrowHeight={260}
        />
      </div>
    </div>
  );
};
export default ToothMovementRestriction;
